export const parseSseEventData = (e: Event) => {
  const event = e as MessageEvent<string>;
  return JSON.parse(event.data);
};
